
import React, { useEffect, useMemo } from 'react';
import cx from 'classnames';
import mStyles from './mInnerToast.module.scss';
import pStyles from './pc.innerToast.module.scss';
import { isMobile } from '@/utils';

export interface IInnerToast {
  className?: string;
  rootClassName?: string;
  style?: React.CSSProperties;
  type?: 'dark' | 'light',
  duration?: number;
  content?: string | React.ReactNode;
  maskClickable?: boolean,
  animate?: boolean;
  renderIcon?: string | React.ReactNode;
  onClose?: () => void; // Toast 消失时触发
  isPc?: boolean;
}

const InnerToast = ({
  renderIcon,
  className = '',
  rootClassName = '',
  style = {},
  type = 'dark',
  content = '',
  duration = 2000,
  maskClickable = false,
  onClose = () => {},
  isPc,
}: IInnerToast) => {
  useEffect(() => {
    if (duration !== 0) {
      setTimeout(() => { // 定时关闭 Toast
        onClose?.();
      }, duration);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const Styles = useMemo(() => {
    if (isPc === undefined) {
      return isMobile ? mStyles : pStyles;
    }
    return isPc ? pStyles : mStyles;
  }, [isPc])

  return (
    <div className={cx(
      Styles.innerToastWrapper,
      className,
      {
        [Styles.light]: type === 'light',
      }
    )}>
      <div
        className={cx(Styles.root, rootClassName)}
        style={{
          pointerEvents: maskClickable ? 'auto' : 'none',
          ...style,
        }}
      >
        { renderIcon }
        {
          typeof content === 'string' ? <div className={Styles.content}>{content}</div> : content
        }
      </div>
    </div>
  );
};

export default InnerToast;
